module.exports = __webpack_public_path__ + "img/thunder-icon.f8422382.svg";